module.exports = __webpack_public_path__ + "media/images/flags/64/India-61b042a09cb386a3ae85462dc470bd05.png";